import { PendingSubscriptionEvent } from "../../../../../types"

interface SummaryProps {
  event: PendingSubscriptionEvent
}

const Summary = ({ event }: SummaryProps) => {
  const { details, event_type } = event

  switch (event_type) {
    case "pending_subscription.created": {
      const triggerRate = details?.trigger_rate
      const firstName = details?.first_name
      const lastName = details?.last_name
      const name =
        firstName && lastName ? `${firstName} ${lastName}` : "Unknown"
      const rate =
        triggerRate != null
          ? `${Number(triggerRate).toFixed(2)}%`
          : "Unknown rate"
      return <>{`Created for ${name} at ${rate}`}</>
    }

    case "pending_subscription.updated": {
      return <>Updated Dream rate</>
    }

    case "pending_subscription.cancelled":
      return <>Dream rate cancelled</>

    case "pending_subscription.priced":
      return <>Dream rate priced</>

    case "pending_subscription.close_to_converting":
      return <>Pricing run. Target price not met</>

    case "pending_subscription.converted":
      return <>Target price met. Active rate drop.</>

    case "pending_subscription.force_price": {
      const bestRate = details?.best_rate
      return (
        <>
          {bestRate != null
            ? `Force priced at ${Number(bestRate).toFixed(3)}%`
            : "Force priced — no qualifying rates"}
        </>
      )
    }

    case "pending_subscription.error": {
      const errorMessage = details?.error_message
      return (
        <>{errorMessage ? errorMessage.substring(0, 20) + "..." : "error"}</>
      )
    }

    default:
      return <></>
  }
}

export default Summary
